export const enum Gender {
  COMMON,
  NEUTER,
}
